export default __webpack_public_path__ + "static/img/21.66a7289.png";